import { StateSchema } from 'app/config/storeConfig/types';
import { GlobalConfirmModalData } from '../types';

export const getGlobalConfirmModalData = (state: StateSchema): Nullable<GlobalConfirmModalData> =>
  state.globalConfirmModal.globalConfirmModalData;
